import { useNavigate } from 'react-router-dom';
import SundaySchoolLayout from '../SundaySchoolLayout';
import { getSundaySchoolSession, clearSundaySchoolSession } from '../sundaySchoolSession';

const MENU_ITEMS = [
  { icon: '✏️', label: '프로필 수정' },
  { icon: '🔔', label: '알림 설정' },
  { icon: '🔐', label: '계정 및 권한' },
  { icon: '❓', label: '도움말' },
];

export default function SundaySchoolMy() {
  const session = getSundaySchoolSession();
  const user = session?.user;
  const church = session?.church;
  const navigate = useNavigate();

  const onLogout = () => {
    clearSundaySchoolSession();
    navigate('/manage-ss/');
  };

  return (
    <SundaySchoolLayout footNote="마이페이지 · 관리자 계정 정보">
      <div className="admin-my">
        <div className="page-head">
          <div>
            <h1>마이페이지 👤</h1>
            <div className="sub">관리자 계정 정보를 확인하고 관리하세요</div>
          </div>
        </div>

        <div className="card card-pad mb16 flex">
          <span className="avatar avatar-lg av-2">{(user?.name ?? '김').slice(0, 1)}</span>
          <div className="grow">
            <div style={{ fontWeight: 800, fontSize: 18 }}>{user?.name ?? '-'}</div>
            <div className="muted mt8">
              {church?.name ?? '-'} · {user?.staffRole || '관리자'}
            </div>
          </div>
        </div>

        <div className="card mb16">
          {MENU_ITEMS.map((item, i) => (
            <div
              key={item.label}
              className="row"
              style={{
                padding: '14px 20px',
                borderBottom: i < MENU_ITEMS.length - 1 ? '1px solid var(--line)' : 'none',
              }}
            >
              <span>{item.icon}</span>
              <span className="grow t">{item.label}</span>
              <span className="muted">›</span>
            </div>
          ))}
        </div>

        <button className="btn btn-outline btn-block" onClick={onLogout}>
          로그아웃
        </button>
      </div>
    </SundaySchoolLayout>
  );
}
